/* Firkin Jelly — barre d'ajout au panier volante sur les fiches sacs.
   Les fiches sacs n'ont pas le bouton classique : c'est le sélecteur de lots (wb-bundle) qui ajoute au panier.
   On réutilise la barre volante du thème (réglage « Barre fixe » de la section WB — Produit) en la branchant sur ce bouton. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function wire(section) {
    if (section.__wbStickyBundle) return;
    if (section.querySelector('[data-wbp-atc]')) return; /* fiche classique : déjà gérée par wb-product.js */
    var bar = section.querySelector('[data-wbp-sticky-bar]');
    var stickyAtc = section.querySelector('[data-wbp-sticky-atc]');
    var bundleAdd = section.querySelector('[data-bundle-add]');
    if (!bar || !stickyAtc || !bundleAdd) return;
    section.__wbStickyBundle = true;

    var root = bundleAdd.closest('[data-wb-bundle]') || section;
    var total = root.querySelector('[data-bundle-add-total]');
    var price = section.querySelector('[data-wbp-sticky-price]');
    var compare = section.querySelector('[data-wbp-sticky-compare]');

    function syncPrice() {
      if (total && price) {
        var t = (total.textContent || '').trim();
        if (t) price.textContent = t;
      }
      if (compare) {
        var tier = root.querySelector('.wb-bundle__tier.is-active');
        var single = !tier || tier.getAttribute('data-tier') === '1';
        compare.style.display = single && compare.textContent.trim() ? '' : 'none';
      }
    }
    if (total) new MutationObserver(syncPrice).observe(total, { childList: true, characterData: true, subtree: true });
    syncPrice();

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        bar.classList.toggle('is-visible', bundleAdd.getBoundingClientRect().bottom <= 0);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    stickyAtc.addEventListener('click', function () {
      if (bundleAdd.disabled || stickyAtc.classList.contains('is-loading')) return;
      stickyAtc.classList.add('is-loading');
      bundleAdd.click();
      setTimeout(function () {
        var note = root.querySelector('[data-bundle-note]');
        if (note && !note.hidden && note.getAttribute('data-state') === 'error') {
          stickyAtc.classList.remove('is-loading');
          bundleAdd.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        }
      }, 400);
      setTimeout(function () { stickyAtc.classList.remove('is-loading'); }, 8000);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[id^="wb-product-"]'), wire);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 50); });
})();
